import { type FC } from "react";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  type AccordionProps,
} from "@chakra-ui/accordion";
import { Icon } from "@chakra-ui/react";
import { type IconType } from "react-icons";

export interface AskedItem {
  readonly title: string;
  readonly panel: string;
  readonly icon?: IconType;
}

export interface AskedCardProps extends AccordionProps {
  readonly items: AskedItem[];
}

export const AskedCard: FC<AskedCardProps> = (props) => {
  const { items, ...rest } = props;
  return (
    <Accordion {...rest}>
      {items.map((item, key) => {
        return (
          <AccordionItem key={key}>
            <AccordionButton>
              {item.icon !== undefined && <Icon color="green" as={item.icon} />}
              <Box flex="1" textAlign="left" pl="1.08rem">
                <Typography variant="text2">{item.title}</Typography>
              </Box>
              <AccordionIcon color="mono.dark.54" />
            </AccordionButton>
            <AccordionPanel>
              <Typography variant="sentence3">{item.panel}</Typography>
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
